export function NubankPayForm() {
  return <></>;
}
